<template>
  <admin-base
    add-btn-text="Add New User"
    :add-btn-permission="addUserPermission"
    @create="showUserModal"
    @search="val => search = val"
  >
    <template v-slot:auxiliary-actions>
      <v-checkbox class="mr-2" v-model="activeOnly" label="Active Users only" hide-details></v-checkbox>
    </template>
    <admin-users-table
      ref="table"
      :search="search"
      :activeOnly="activeOnly"
      @edit="showUserModal"
      @history="showHistoryModal"
      @addSignature="showSignatureModal"
    />
    <users-modal-form
      ref="userModal"
      @success="refreshTable"
    />
    <users-history-modal
      ref="historyModal"
    />
    <signature-modal
      ref="signatureModal"
      @success="refreshTable"
    />
  </admin-base>
</template>

<script>
import AdminBase from '@/components/admin/Base';
import AdminUsersTable from '@/components/admin/controls/users/UsersTable';
import UsersModalForm from '@/components/admin/controls/users/forms/user/UsersModalForm';
import UsersHistoryModal from '@/components/admin/controls/users/HistoryModal';
import SignatureModal from '@/components/admin/controls/users/SignatureModal';


export default {
  name: 'AdminControlsUsersView',
  components: {
    AdminBase,
    AdminUsersTable,
    UsersModalForm,
    UsersHistoryModal,
    SignatureModal,
  },
  data: () => ({
    search: null,
    activeOnly: true,
  }),
  computed: {
    addUserPermission: vm => vm.$permissions.ADD_USERS,
  },
  methods: {
    showUserModal(user) {
      this.$refs.userModal.open(this.$utils.deepCopy(user));
    },
    showHistoryModal(user) {
      this.$refs.historyModal.open(user);
    },
    refreshTable() {
      this.$refs.table.fetch();
    },
    showSignatureModal(user) {
      this.$refs.signatureModal.open(user);
    },
  },
};
</script>
